module.exports = __webpack_public_path__ + "img/card_right.18d10bef.png";